import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const CTAHero = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const heroData =
    labels.menuPages?.howItWorks?.callToActionSection?.hero || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-16"
    >
      <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
        {heroData.title || "Redo att Börja?"}
      </h2>
      <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
        {heroData.description ||
          "Gör som tusentals andra nöjda kunder. Starta din bilförsäljning eller hitta din nästa drömbil idag - helt kostnadsfritt!"}
      </p>
    </motion.div>
  );
};

export default CTAHero;
